
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators",
      function () {
        return require("private-next-pages/calculators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators"])
      });
    }
  